import type { MobileOrDesktop } from '@cc-shopping/utils/deviceType/types';

export const forceDesktopOrMobile = (deviceType?: string): MobileOrDesktop => {
  if (deviceType === 'desktop') {
    return 'desktop';
  }

  return 'mobile';
};

export const BCC_PLACEHOLDER_SEQUENCING_SLUG = 'bcc';
